/**
 * The report answers a diocese role keeps on this device (../routes/laporan/sumber): one entry per
 * question, under `simu:laporan:`, each keyed by the user and the role that asked (review C-1,
 * release 19: an answer the admin keuskupan kept holds Profil umat's sensitive sections, which the
 * uskup or a dekan on the same device must never see). They go with the data: when a change of
 * user clears the device (../auth/gantiPengguna) and in the wipe (../auth/wipe). Kept apart from
 * `sumber` so the shell's launch path carries no report code.
 */
// Legacy storage name from SIMU; kept so devices keep their data (pinned: test/nama-warisan.test.ts).
export const AWALAN_CACHE_LAPORAN = 'simu:laporan:'

function storage(): Storage | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage
  } catch {
    return null
  }
}

/** Every kept report answer's key on this device. */
export function kunciCacheLaporan(): string[] {
  const s = storage()
  if (s === null) return []
  const kunci: string[] = []
  try {
    for (let i = 0; i < s.length; i += 1) {
      const k = s.key(i)
      if (k?.startsWith(AWALAN_CACHE_LAPORAN) === true) kunci.push(k)
    }
  } catch {
    return []
  }
  return kunci
}

/** Remove every kept report answer (a change of user that clears the device). */
export function hapusCacheLaporan(): void {
  const s = storage()
  if (s === null) return
  for (const k of kunciCacheLaporan()) {
    try {
      s.removeItem(k)
    } catch {
      // Storage refused: nothing else to do.
    }
  }
}
